import { render, staticRenderFns } from "./ReservationLandingPageBuilder.vue?vue&type=template&id=201a3c9a&scoped=true"
import script from "./ReservationLandingPageBuilder.vue?vue&type=script&lang=js"
export * from "./ReservationLandingPageBuilder.vue?vue&type=script&lang=js"
import style0 from "./ReservationLandingPageBuilder.vue?vue&type=style&index=0&id=201a3c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a3c9a",
  null
  
)

export default component.exports